import { RegularSportTicketItem } from '@superbet-group/web.types';

import ISelection from '@models/betSlip/ISelection';
import SportSelection from '@models/betSlip/SportSelection';

import { transformSportSelection } from './transformSportSelection';
import { PropagatedSelectionAttributes } from './types';

export function transformSelectionToTicketItem(
    item: ISelection,
    propagatedAttributes: PropagatedSelectionAttributes,
): RegularSportTicketItem {
    if (item instanceof SportSelection) {
        return transformSportSelection(item, propagatedAttributes);
    } else {
        throw new Error('Invalid selection type.');
    }
}
